import { ref, unref } from 'vue';
import SalesTransactionPartiesAPI from 'dashboard/api/salesTransactionParties';

export const LABOR_CERTIFICATE_TYPE_ID = '50';
export const LABOR_CERTIFICATE_DELAY = 5000;

const documentTypes = artifact =>
  artifact?.document_types ||
  artifact?.tipo_documento_ids ||
  artifact?.metadata?.document?.document_types ||
  [];

export const hasLaborCertificate = party =>
  [...(party?.document_artifacts || []), ...(party?.documents || [])].some(
    artifact =>
      documentTypes(artifact).some(
        document =>
          String(document?.id || document?.tipo_documento_id) ===
          LABOR_CERTIFICATE_TYPE_ID
      )
  );

export function useSalesPartyLaborCertificateCheck({ transactionId, t }) {
  const open = ref(false);
  const items = ref([]);
  let closeTimer;

  const close = () => {
    open.value = false;
    items.value = [];
  };

  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, LABOR_CERTIFICATE_DELAY);
  };

  const check = async ({ partyId, party }) => {
    if (!partyId || hasLaborCertificate(unref(party))) return null;

    open.value = true;
    items.value = [
      {
        doc: 'debitos_trabalhistas',
        status: 'loading',
        label: t('SALES_PARTIES.CERTIFICATES.LABOR.LOADING'),
      },
    ];

    try {
      const response = await SalesTransactionPartiesAPI.checkLaborCertificate(
        unref(transactionId),
        partyId
      );
      const status = response?.data?.data?.status;
      const success = ['success', 'already_present'].includes(status);
      const label = success
        ? t('SALES_PARTIES.CERTIFICATES.LABOR.SUCCESS')
        : t('SALES_PARTIES.CERTIFICATES.LABOR.NOT_FOUND');
      items.value = [
        {
          doc: 'debitos_trabalhistas',
          status: success ? 'success' : 'error',
          label,
        },
      ];
      scheduleClose();
      return response;
    } catch {
      items.value = [
        {
          doc: 'debitos_trabalhistas',
          status: 'error',
          label: t('SALES_PARTIES.CERTIFICATES.LABOR.NOT_FOUND'),
        },
      ];
      scheduleClose();
      return null;
    }
  };

  return { check, close, items, open };
}
